import ajax from '@/utils/ajax'

/**
 * @module 能链品牌通
 */

// 品牌通运营报告详情（baseURL 已含 /services/m1/，实际请求 /services/m1/brandPass/reportDetail）
export const getReportDetail = params => ajax.post('brandPass/reportDetail', params)

// 品牌通油站列表（实际请求 /services/m1/brandPass/getAllGasInfoList）
export const getAllGasInfoList = params => ajax.post('brandPass/getAllGasInfoList', params)
